var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachGreen = function SvgAttachGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 144"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4cc0ad",
    d: "M5 18a5.006 5.006 0 0 1-5-5V5a5 5 0 0 1 10 0v2a3 3 0 0 1-6 0V6a1 1 0 0 1 2 0v1a1 1 0 0 0 2 0V5a3 3 0 0 0-6 0v8a3 3 0 0 0 6 0 1 1 0 0 1 2 0 5.006 5.006 0 0 1-5 5",
    "data-name": "Path 22"
  }))));
};
export default SvgAttachGreen;